/**
 * Shared external links configuration.
 * Single source of truth for social media, app store, and site URLs
 * used across all projects (website, client, console).
 */

export const socialLinks = {
  facebook: '',
  instagram: '',
  linkedin: '',
} as const;

export const appStoreLinks = {
  /** Bubba app for pet owners */
  client: {
    ios: '',
    android: '',
  },
  /** Bubba app for business partners */
  console: {
    ios: '',
    android: '',
  },
} as const;

export const siteUrl = 'https://bubba.pet' as const;
